/**
 * Self-contained ResamplerProcessor code for AudioWorklet.
 * Inlined to eliminate any network dependency, MIME-type issue, or path resolution failure.
 */
export const RESAMPLER_WORKLET_CODE = `
class ResamplerProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.targetSampleRate = 16000;
    this.chunkSize = 512; // 32ms @ 16kHz
    this.outputBuffer = new Float32Array(this.chunkSize);
    this.outputIndex = 0;
    this.resamplePhase = 0.0;
  }

  process(inputs) {
    const input = inputs[0];
    if (!input || input.length === 0) return true;

    const numChannels = input.length;
    const channel0 = input[0];
    if (!channel0 || channel0.length === 0) return true;

    const frameCount = channel0.length;
    const mono = new Float32Array(frameCount);

    if (numChannels === 1) {
      mono.set(channel0);
    } else {
      for (let ch = 0; ch < numChannels; ch++) {
        const chan = input[ch];
        if (chan) {
          for (let i = 0; i < frameCount; i++) {
            mono[i] += chan[i] / numChannels;
          }
        }
      }
    }

    const ratio = sampleRate / this.targetSampleRate;

    while (this.resamplePhase < frameCount) {
      const idx = Math.floor(this.resamplePhase);
      const frac = this.resamplePhase - idx;

      const sample0 = mono[idx] || 0.0;
      const sample1 = mono[idx + 1] !== undefined ? mono[idx + 1] : sample0;

      const sample = sample0 + frac * (sample1 - sample0);

      this.outputBuffer[this.outputIndex++] = sample;

      if (this.outputIndex >= this.chunkSize) {
        const chunk = new Float32Array(this.outputBuffer);
        this.port.postMessage({ type: 'audio', buffer: chunk }, [chunk.buffer]);
        this.outputIndex = 0;
      }

      this.resamplePhase += ratio;
    }

    this.resamplePhase -= frameCount;
    return true;
  }
}

registerProcessor('resampler-processor', ResamplerProcessor);
`;
